import { Box, Image } from '@chakra-ui/react';
import logo from '../../../assets/logo.svg';

export const CustomerNavMobile = () => {
  return (
    <Box
      px='3'
      py='2'
      borderBottomWidth='1px'
      display={{ base: 'block', lg: 'none' }}
      position='sticky'
      top='0'
      bg='white'
      zIndex='sticky'>
      <Image height='7' src={logo} alt='logo' />
    </Box>
  );
};
